(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["al-collapsible"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.AlCollapsible) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setLabel(toggle, expanded) {
    var el = toggle.querySelector('[data-al-collapsible-label]');
    if (!el) return;
    var txt = expanded ? el.getAttribute('data-less') : el.getAttribute('data-more');
    if (txt == null) return;
    if (el.firstChild && el.firstChild.nodeType === 3) {
      el.firstChild.nodeValue = txt;
    } else {
      el.insertBefore(document.createTextNode(txt), el.firstChild);
    }
  }

  function whenDone(el, fn) {
    var t;
    var done = function (e) {
      if (e && e.target !== el) return;
      el.removeEventListener('transitionend', done);
      clearTimeout(t);
      fn();
    };
    t = setTimeout(done, 550);
    el.addEventListener('transitionend', done);
  }

  function expand(region, toggle) {
    toggle.setAttribute('aria-expanded', 'true');
    setLabel(toggle, true);
    if (reduce) { region.style.maxHeight = 'none'; return; }
    region.style.maxHeight = region.getBoundingClientRect().height + 'px';
    void region.offsetHeight;
    region.style.maxHeight = region.scrollHeight + 'px';
    whenDone(region, function () {
      if (toggle.getAttribute('aria-expanded') === 'true') region.style.maxHeight = 'none';
    });
  }

  function collapse(region, toggle) {
    toggle.setAttribute('aria-expanded', 'false');
    setLabel(toggle, false);
    if (reduce) { region.style.maxHeight = ''; return; }
    var full = region.getBoundingClientRect().height;
    region.style.maxHeight = '';
    var target = region.getBoundingClientRect().height;
    region.style.maxHeight = full + 'px';
    void region.offsetHeight;
    region.style.maxHeight = target + 'px';
  }

  function overflowing(region) {
    return region.scrollHeight - region.clientHeight > 2;
  }

  function setup(group) {
    if (group.alcReady) return;
    var region = group.querySelector('[data-al-collapsible]');
    var toggle = group.querySelector('[data-al-collapsible-toggle]');
    if (!region || !toggle) return;
    group.alcReady = true;

    function refresh() {
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      toggle.hidden = !overflowing(region);
    }
    refresh();

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') collapse(region, toggle);
      else expand(region, toggle);
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(refresh, 150);
    });
  }

  function scan(root) {
    var groups = (root || document).querySelectorAll('[data-al-collapsible-group]');
    Array.prototype.forEach.call(groups, setup);
  }

  window.AlCollapsible = { scan: scan };

  function init() { scan(document); }
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target || document);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
